/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as GamesgamesgamesgamesDefs from "../../../games/gamesgamesgamesgames/defs.defs.js";

const $nsid = "place.stream.game.search";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"q":/*#__PURE__*/ l.string({"minLength":1,"maxLength":200}),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 20)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"totalResults":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"results":/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<GamesgamesgamesgamesDefs.GameSummaryView>((() => GamesgamesgamesgamesDefs.gameSummaryView) as any),/*#__PURE__*/ l.typedRef<GamesgamesgamesgamesDefs.ProfileSummaryView>((() => GamesgamesgamesgamesDefs.profileSummaryView) as any),/*#__PURE__*/ l.typedRef<GamesgamesgamesgamesDefs.PlatformSummaryView>((() => GamesgamesgamesgamesDefs.platformSummaryView) as any),/*#__PURE__*/ l.typedRef<GamesgamesgamesgamesDefs.CollectionSummaryView>((() => GamesgamesgamesgamesDefs.collectionSummaryView) as any),/*#__PURE__*/ l.typedRef<GamesgamesgamesgamesDefs.EngineSummaryView>((() => GamesgamesgamesgamesDefs.engineSummaryView) as any)], false), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Search for games and other entities via the games.gamesgamesgamesgames catalog. Proxied from the configured games API. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
